import { Component, Inject } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { SyncStatus } from '@ionic-native/code-push/ngx';
import { Config, LoadingController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as markerjs2 from 'markerjs2';
import { register } from 'swiper/element/bundle';
import { CodePushService } from 'src/app/shared/services/code-push/code-push.service';
import { EnvironmentService } from 'src/app/shared/services/environment/environment.service';
import { environment } from 'src/environments/environment';
import { IPipelineRegistry } from './shared/pipeline/contracts/start/pipeline-registry';
import { PipelineRegistry } from './shared/pipeline/start/pipeline-registry';
import { TrackerService } from './shared/services/tracker.service';

// Wird in Ionic Upgrade Guide to 7 außerhalb der Komponente hier ausgeführt
register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private platform: Platform,
    private config: Config,
    private codePushService: CodePushService,
    private environmentService: EnvironmentService,
    private readonly tracker: TrackerService,
    private _loadingController: LoadingController,
    @Inject(PipelineRegistry) private _pipelineRegistry: IPipelineRegistry
  ) {
    this.initializeApp();
    markerjs2.Activator.addKey(environment.markerjs2Key);
  }

  async initializeApp() {
    this.initTranslate();
    await this.environmentService.init();
    await this.platform.ready();
    await this._pipelineRegistry.start();

    const branch = this.environmentService.branch;

    const release = `alberta-${this.platform.is('capacitor') ? 'app' : 'web'}@${this.environmentService.version}`;

    if (!this.platform.is('hybrid')) {
      return;
    }

    await SplashScreen.hide();
    this.tracker.setVersion(branch, release);
  }

  initTranslate() {
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }

  async codePushSync() {
    const loading = await this._loadingController.create({
      message: '',
    });

    (await this.codePushService.sync())?.subscribe(async syncStatus => {
      switch (syncStatus) {
        case SyncStatus.CHECKING_FOR_UPDATE:
          await loading.present();
          loading.message = this.translate.instant('codePushStatus.checking');
          break;
        case SyncStatus.DOWNLOADING_PACKAGE:
          loading.message = this.translate.instant('codePushStatus.downloading');
          break;
        case SyncStatus.INSTALLING_UPDATE:
          loading.message = this.translate.instant('codePushStatus.installing');
          break;
        case SyncStatus.UPDATE_INSTALLED:
          loading.message = this.translate.instant('codePushStatus.installed');
          await this.codePushService.restartApplication();
          break;
        case SyncStatus.UP_TO_DATE:
          const upToDateTranslation = this.translate.instant('codePushStatus.updated');
          loading.message = upToDateTranslation;
          window.logger.info(upToDateTranslation);
          await loading.dismiss().catch(error => window.logger.error('Dismiss of loading window failed.', error));
          break;
        case SyncStatus.ERROR:
        case SyncStatus.UPDATE_IGNORED:
          await loading.dismiss().catch(error => window.logger.error('Dismiss of loading window failed.', error));
          break;
      }
    });
  }
}
